import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {FormGroup, FormLabel} from '@material-ui/core';
import ObjectUtils from "../../../utils/ObjectUtils";

const styles = theme => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        '&$checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#52d869',
                opacity: 1,
                border: 'none',
            },
        },
        '&$focusVisible $thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {}
});

const _BaseSwitchWithoutStyle =
    ({
         handleFieldChange,
         label = "",
         checked = true,
         disabled = false,
         classes
     }) => {
        return <FormControlLabel
            control={
                <Switch
                    classes={{
                        root: classes.root,
                        switchBase: classes.switchBase,
                        thumb: classes.thumb,
                        track: classes.track,
                        checked: classes.checked
                    }}
                    disableRipple
                    disabled={disabled}
                    checked={checked}
                    onChange={e => handleFieldChange(e.target.checked)}
                />
            }
            label={label}
        />;
    }

const BaseSwitch = withStyles(styles)(_BaseSwitchWithoutStyle);

const SwitchField =
    ({
         label = "",
         handleFieldChange,
         checked = true,
         disabled = false,
         classes = "",
         themeName = 'form',
         checkedLabel = 'Active',
         uncheckedLabel = 'Inactive',
         width = 5
     }) => {
        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 ") + classes }>

                <FormGroup
                    row
                    disabled={disabled}
                >
                    {!ObjectUtils.isEmpty(label) &&
                    <FormLabel
                        component="legend"
                        disabled={disabled}
                    >
                        {label}
                    </FormLabel>
                    }
                    <BaseSwitch
                        label={checked ? checkedLabel : uncheckedLabel}
                        handleFieldChange={handleFieldChange}
                        checked={checked}
                        disabled={disabled}
                    />
                </FormGroup>
            </div>
        );
    }

const SwitchFieldWithoutLabel =
    ({
         handleFieldChange,
         checked = true,
         disabled = false,
     }) => {
        return (
            <FormGroup row>
                <BaseSwitch
                    label={""}
                    handleFieldChange={handleFieldChange}
                    checked={checked}
                    disabled={disabled}
                />
            </FormGroup>
        );
    }

export default SwitchField;
export {
    SwitchFieldWithoutLabel
};
